import React, { useEffect, useRef, useState } from "react";
import { Typography } from "@progress/kendo-react-common";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  flightPlaceActiveInactive,
  deleteFlightPlace,
  getAllFlightPlaces,
} from "./services/flightPlace.services";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import { clearStateID } from "../state/stateSlice";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Button } from "@progress/kendo-react-buttons";
import {
  CompositeFilterDescriptor,
  filterBy,
} from "@progress/kendo-data-query";
import {
  GridCellProps,
  GridCustomCellProps,
  GridCustomHeaderCellProps,
  GridFilterChangeEvent,
  GridPageChangeEvent,
  Grid as KendoGrid,
  GridColumn as Column,
} from "@progress/kendo-react-grid";
import { HeaderThElement } from "@progress/kendo-react-data-tools";
import { LoadingPanel } from "../../components/layout/Loading";
import IconButton from "../../components/common/IconButton";
import { MdDelete } from "react-icons/md";

import { Switch, TextBox } from "@progress/kendo-react-inputs";
import { setFlightPlaceFilter, setFlightPlaceID } from "./flightPlaceSlice";
import ButtonCreate from "../../components/drawer/ButtonCreate";

import ButtonEdit from "../../components/drawer/ButtonEdit";
import {
  DELETE_ACCESS,
  EDIT_ACCESS,
  INSERT_ACCESS,
} from "../../_contstants/common";
import { checkAcessRights } from "../../_helper/helper";
import _debounce from "lodash/debounce";
import { filterClearIcon } from "@progress/kendo-svg-icons";
import { setCurrentPage, setPageLimit } from "../pagination/paginationSlice";

const FlightPlace: React.FC = () => {
  const dispatch = useAppDispatch();

  const isAddAccess = checkAcessRights(location.pathname, INSERT_ACCESS);
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
  const FlightPlaceFilter: any = useAppSelector(
    (state) => state.flightPlace.FlightPlaceFilter
  );

  useEffect(() => {
    const payload = {
      ...FlightPlaceFilter,
      Limit: +pageLimit,
      Skip: +currentPage * +pageLimit,
    };

    dispatch(getAllFlightPlaces(payload));
    return () => {
      dispatch(closeDialog());
    };
  }, []);
  return (
    <>
      <DeleteFlightPlaceDialog />
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "4px 20px 20px 0",
          }}
        >
          <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
            Flight Places List
          </Typography.h4>
          {isAddAccess && (
            <ButtonCreate
              label="Create Flight Place"
              drawerName="flightPlaceForm"
            />
          )}
        </GridLayoutItem>
        <GridLayoutItem>
          <FlightPlacesGridComponent />
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

const FlightPlacesGridComponent: React.FC = () => {
  const gridRef = useRef<any>(null);
  const dispatch = useAppDispatch();
  const FlightPlaceList = useAppSelector(
    (state) => state.flightPlace.FlightPlaceList
  );
  const isEditAccess = checkAcessRights(location.pathname, EDIT_ACCESS);
  const isDeleteAccess = checkAcessRights(location.pathname, DELETE_ACCESS);
  const loading = useAppSelector((state) => state.flightPlace.loading);
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
  const FlightPlaceFilter: any = useAppSelector(
    (state) => state.flightPlace.FlightPlaceFilter
  );

  useEffect(() => {
    const payload = {
      ...FlightPlaceFilter,
      Limit: +pageLimit,
      Skip: +currentPage * +pageLimit,
    };
    dispatch(getAllFlightPlaces(payload));
  }, [currentPage, pageLimit]);

  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);

  const pageChange = (event: GridPageChangeEvent) => {
    const newPage = event.page.skip / event.page.take;
    dispatch(setPageLimit(event.page.take));
    dispatch(setCurrentPage(newPage));
  };

  if (loading) return <LoadingPanel gridRef={gridRef} />;

  const MyEditCommandCell = (props: GridCellProps) => {
    const handleOpenDeleteDialog = (ID: number) => {
      dispatch(openDialog("deleteFlightPlace"));
      dispatch(setFlightPlaceID(ID));
    };
    return (
      <td
        className="action-td"
        style={{
          ...props.style,
        }}
      >
        {isEditAccess && (
          <ButtonEdit ID={props.dataItem.ID} drawerName="flightPlaceForm" />
        )}
        {isDeleteAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Delete"
            onClick={() => handleOpenDeleteDialog(props.dataItem.ID)}
          >
            <MdDelete
              className="absolute-position"
              style={{ fontSize: "24px" }}
            />
          </IconButton>
        )}
      </td>
    );
  };

  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
  };

  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className="table-header"
    >
      {props.children}
    </HeaderThElement>
  );

  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };

  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  const MyActiveInActtiveCommandCell = (props: GridCellProps) => {
    const [IsActive, setIsActive] = useState<boolean>(props.dataItem.IsActive);

    const handleActiveInActive = () => {
      setIsActive(!IsActive);
      const data = {
        ID: props.dataItem.ID,
        IsActive: !IsActive,
      };
      dispatch(flightPlaceActiveInactive(data)).then((response: any) => {
        const payload = {
          ...FlightPlaceFilter,
          Limit: +pageLimit,
          Skip: +currentPage * +pageLimit,
        };
        if (response.payload?.data?.Status === 200) {
          dispatch(getAllFlightPlaces(payload));
        } else {
          dispatch(getAllFlightPlaces(payload));
        }
      });
    };

    return (
      <td style={{ textAlign: "center" }}>
        <Switch
          name="IsActive"
          disabled={isEditAccess ? false : true}
          checked={IsActive}
          onChange={handleActiveInActive}
          size="small"
        />
      </td>
    );
  };

  return (
    <KendoGrid
      style={{ maxHeight: "calc(100vh - 152px)" }}
      filterable={true}
      filter={filter}
      data={filter ? filterBy(FlightPlaceList, filter) : FlightPlaceList}
      onFilterChange={handleFilterChange}
      onPageChange={pageChange}
      resizable={true}
      skip={currentPage * pageLimit}
      take={pageLimit}
      total={FlightPlaceList[0]?.ItemCount || FlightPlaceList?.length}
      pageable={{
        buttonCount: 5,
        pageSizes: [10, 50, 100, 300, 500],
        pageSizeValue: pageLimit,
        type: "input",
      }}
      cells={{
        headerCell: HeaderCustomCell,
        data: MyDataCustomCell,
      }}
    >
      <Column
        field="Airport"
        title="Flight Place Name"
        filterCell={CommonFilterCell}
        cell={(props: any) => (
          <td
            // className={"hoverableName"}
            className={`${isEditAccess ? "hoverableName" : "normalName"}`}
          >
            {isEditAccess ? (
              <ButtonEdit
                ID={props.dataItem.ID}
                drawerName="flightPlaceForm"
                label={props.dataItem?.Airport}
              />
            ) : (
              props.dataItem?.Airport
            )}
          </td>
        )}
      />

      <Column
        field="Value"
        title="Flight Place Code"
        filterCell={CommonFilterCell}
      />
      <Column field="Name" title="Country " filterCell={CommonFilterCell} />
      <Column field="CountryCode" title="Country Code" />
      <Column field="CurrencyCode" title="Currency Code" />
      <Column
        field="IsFavorite"
        title="Favourite Place"
        cell={(props: any) => {
          return (
            <td style={{ textAlign: "center" }}>
              {props.dataItem.favourite_places ? "TRUE" : "FALSE"}
            </td>
          );
        }}
        filterable={false}
        locked={true}
      />
      <Column
        field="ID"
        title="Status"
        cell={MyActiveInActtiveCommandCell}
        width={"90px"}
        filterable={false}
        locked={true}
      />

      {(isEditAccess || isDeleteAccess) && (
        <Column
          field="ID"
          title="Actions"
          cell={MyEditCommandCell}
          width={"110px"}
          filterable={false}
        />
      )}
    </KendoGrid>
  );
};

const DeleteFlightPlaceDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const FlightPlaceID = useAppSelector(
    (state) => state.flightPlace.FlightPlaceID
  );
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
  const FlightPlaceFilter: any = useAppSelector(
    (state) => state.flightPlace.FlightPlaceFilter
  );

  const handleDeleteAction = async (ID: number | null) => {
    if (ID) {
      const response = await dispatch(deleteFlightPlace(ID));
      const payload = {
        ...FlightPlaceFilter,
        Limit: +pageLimit,
        Skip: +currentPage * +pageLimit,
      };
      if (response.payload?.Data?.Status === 200) {
        dispatch(getAllFlightPlaces(payload));
        dispatch(closeDialog());
        dispatch(clearStateID());
      } else {
        dispatch(getAllFlightPlaces(payload));
        dispatch(closeDialog());
        dispatch(clearStateID());
      }
    }
  };

  return (
    <>
      {dialogName === "deleteFlightPlace" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete FlightPlace?"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this Flight Place?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(FlightPlaceID)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

const CommonFilterCell = (props: any) => {
  const dispatch = useAppDispatch();
  const currentPage = useAppSelector((state) => state.pagination.currentPage);
  const pageLimit = useAppSelector((state) => state.pagination.pageLimit);
  const FlightPlaceFilter: any = useAppSelector(
    (state) => state.flightPlace.FlightPlaceFilter
  );
  const isFilterRef = useRef(true);
  const [inputValue, setInputValue] = useState(props.value || "");
  const [inputField, setInputField] = useState(props.field || "");

  const onChange = (event: any) => {
    setInputValue(event.target.value);
    setInputField(event.target.name);
  };

  const delayedApiCall = React.useCallback(
    _debounce((updatedFilters: any) => {
      const payload = {
        ...updatedFilters,
        Limit: +pageLimit,
        Skip: +currentPage * +pageLimit,
      };

      dispatch(getAllFlightPlaces(payload));
    }, 500),
    [dispatch]
  );

  useEffect(() => {
    if (!isFilterRef.current) {
      const updatedFilters = {
        ...FlightPlaceFilter,
        [inputField]: inputValue,
      };
      dispatch(setFlightPlaceFilter(updatedFilters));
      delayedApiCall(updatedFilters);
    } else {
      isFilterRef.current = false;
    }
    return () => {
      delayedApiCall.cancel();
    };
  }, [inputValue, delayedApiCall]);

  const onClearButtonClick = (event: any) => {
    event.preventDefault();
    props.onChange({
      value: null,
      operator: "",
      syntheticEvent: event,
    });

    const updatedFilters = { ...FlightPlaceFilter, [props.field]: "" };
    dispatch(setFlightPlaceFilter(updatedFilters));

    const payload = {
      ...updatedFilters,
      Limit: +pageLimit,
      Skip: +currentPage * +pageLimit,
    };

    dispatch(getAllFlightPlaces(payload));
  };

  return (
    <div className="d-flex">
      <TextBox
        value={FlightPlaceFilter[props.field] || ""}
        name={props.field || ""}
        onChange={onChange}
      />
      <Button
        svgIcon={filterClearIcon}
        title="Clear"
        disabled={!FlightPlaceFilter[props.field]}
        onClick={onClearButtonClick}
        type="button"
        style={{
          marginLeft: "8px",
        }}
      ></Button>
    </div>
  );
};

export default FlightPlace;
